import Component from '@averyano/core/src/classes/Component';

import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { set } from 'lodash';
GSAP.registerPlugin(ScrollTrigger);

import each from 'lodash/each';

export default class CoverSection extends Component {
	constructor() {
		super({
			element: '.cover',
			elements: {
				itemsWrapper: document.querySelector('.cover__items-wrapper'),
				aboutWrapper: document.querySelector('.about'),
				designCoverImg: document.querySelector('.designvid__cover'),
				designCoverIframe: document.querySelector('.designvid__video'),
			},
		});
	}

	create() {
		super.createComponent();

		this.itemsWrapper = document.querySelector('.cover__items-wrapper');
		this.aboutWrapper = document.querySelector('.about');
		console.log(this.itemsWrapper, this.aboutWrapper);
		// this.createTimeline();
	}

	createTimeline() {
		// console.log('Making ');
		// this.tl = GSAP.timeline();

		// this.animation = GSAP.to(document.querySelector('.cover__items-wrapper'), {
		// 	// x: 300,
		// 	// yPercent: -30,
		// 	y: -200,
		// 	scale: 1,
		// 	duration: 2,
		// 	ease: 'in.expo',
		// 	scrollTrigger: {
		// 		trigger: this.element,
		// 		start: '2% top',
		// 		end: '82% top',
		// 		scrub: true,
		// 		pinSpacing: true,
		// 		pin: true,
		// 		// markers: true,
		// 	},
		// });
		// console.log(this.animation);
	}

	clearTimeline() {

	}

	addEventListeners() {
		this.elements.designCoverIframe = document.querySelector('.designvid__video');
		this.elements.designCoverImg = document.querySelector('.designvid__cover');
		
		this.elements.designCoverImg.addEventListener('click', () => {
			this.elements.designCoverImg.classList.add('designvid__cover--hidden');
			this.elements.designCoverIframe.classList.remove('designvid__video--hidden');
		});
	}

	destroy() {
		super.destroy();
		// this.clearTimeline();
	}
}
